import { c as _c } from "react/compiler-runtime";
import { useProviders } from "@/hooks/use-providers";
import { formatDateTime, formatStaffName } from "@/lib/format-data";
type SignOff = {
  signedOffProviderId?: string;
  signedOffDate?: string | Date;
};
export function useSignOffDetails(signOff) {
  const $ = _c(11);
  const {
    signedOffProviderId,
    signedOffDate
  } = signOff;
  const t0 = !!signedOffProviderId;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      queryOptions: {
        enabled: t0
      }
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isLoading
  } = useProviders(t1);
  let t2;
  if ($[2] !== isLoading || $[3] !== signedOffProviderId) {
    t2 = isLoading ? undefined : signedOffProviderId ? formatStaffName(signedOffProviderId) : undefined;
    $[2] = isLoading;
    $[3] = signedOffProviderId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const providerName = t2;
  let t3;
  if ($[5] !== signedOffDate) {
    t3 = signedOffDate ? formatDateTime(signedOffDate) : undefined;
    $[5] = signedOffDate;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const formattedDate = t3;
  const t4 = isLoading ? "Loading..." : signedOffProviderId && signedOffDate && providerName ? `Signed off on ${formattedDate} by ${providerName}` : "Unknown";
  let t5;
  if ($[7] !== formattedDate || $[8] !== providerName || $[9] !== t4) {
    t5 = {
      providerName,
      formattedDate,
      tooltipText: t4
    };
    $[7] = formattedDate;
    $[8] = providerName;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
export const SignOffTooltipContent = t0 => {
  const {
    signOff
  } = t0;
  const {
    tooltipText
  } = useSignOffDetails(signOff);
  return tooltipText;
};